import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Orders from '@/views/Orders.vue';
import Booking from '@/views/Booking.vue';
import BookingForm from '@/views/BookingForm.vue';
import Booked from '@/views/Booked.vue';
import Item from '@/views/Item.vue';
import Login from '@/views/Login.vue';
import Main from '@/views/Main.vue';
import Transport from '@/views/Transport.vue';
import EstimationPrice from '@/views/EstimationPrice.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    name: 'login',
    path: '/login',
    component: Login,
  },
  {
    path: '/',
    component: Main,
    meta: { requiresAuth: true },
    redirect: { name: 'orders' },
    children: [
      {
        name: 'orders',
        path: 'orders',
        component: Orders,
      },
      {
        name: 'booking',
        path: 'booking',
        component: Booking,
        meta: { requiresAuth: true },
      },
      {
        name: 'booking-form',
        path: 'booking/:id/:type',
        component: BookingForm,
        meta: { requiresAuth: true },
      },
      {
        name: 'booked',
        path: 'booked',
        component: Booked,
        meta: { requiresAuth: true },
      },
      {
        name: 'item',
        path: 'items/:id',
        component: Item,
        meta: { requiresAuth: true },
      },
      {
        name: 'transport',
        path: 'transport/:id',
        component: Transport,
        meta: { requiresAuth: true },
      },
      // Start QuocNV 29092023 add new screen
      {
        name: 'estimation',
        path: 'estimation',
        component: EstimationPrice,
        meta: { requiresAuth: true },
      }
      // End QuocNV 29092023 add new screen
    ],
  },
  { path: '*', redirect: '/login' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(_, __, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
